import PT from 'prop-types';
import AdminControlPortal from 'edrolo/domains/app/side-effects/AdminControlPortal';
import CourseJumper from '../CourseJumper';
import StaffRibbonLink from './StaffRibbonLink';

const StaffRibbon = ({ isStaff, classId, links = [], children }) =>
  isStaff ? (
    <AdminControlPortal>
      {children}
      {classId ? (
        <StaffRibbon.Link
          key="hijack"
          title="Hijack teacher"
          url={`/hijack/class/${classId}/?next=${window.location.pathname}`}
          analyticsPayload={{ class_id: classId }}
        />
      ) : null}
      {links.length
        ? links.map((link, i) => (
            <StaffRibbonLink
              key={link.url}
              title={link.title}
              url={link.url}
              analyticsPayload={link.analyticsPayload || {}}
            />
          ))
        : null}
      <CourseJumper
        instanceId="staff-ribbon-course-jumper"
        placeholder="Jump to course (alt-j)"
      />
    </AdminControlPortal>
  ) : null;

StaffRibbon.propTypes = {
  isStaff: PT.bool.isRequired,
  classId: PT.number,
  links: PT.arrayOf(PT.shape(StaffRibbonLink.propTypes)),
  children: PT.node,
};

StaffRibbon.Link = StaffRibbonLink;

export default StaffRibbon;
